/*
 * TurnReportListItem Messages
 *
 * This contains all the text for the TurnReportListItem component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  daysAgo: {
    id: 'app.containers.TurnReportListItem.daysAgo',
    defaultMessage:
      'Took place {days, number} {days, plural, one {day} other {days}} ago',
  },
  completed: {
    id: 'app.containers.TurnReportListItem.completed',
    defaultMessage: 'Completed',
  },
  uncompleted: {
    id: 'app.containers.TurnReportListItem.uncompleted',
    defaultMessage: 'Uncompleted',
  },
  urgent: {
    id: 'app.containers.TurnReportListItem.urgent',
    defaultMessage: 'Urgent',
  },
});
